import { useSearchParams } from 'react-router-dom';

export const useQueryParams = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    // Get a single param
    const getParam = (key: string) => {
        return searchParams.get(key);
    };

    // Set/update a param
    const setParam = (key: string, value: string) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set(key, value);
        setSearchParams(newParams);
    };

    // Remove a param
    const removeParam = (key: string) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.delete(key);
        setSearchParams(newParams);
    };

    // Set multiple params at once
    const setMultipleParams = (params: Record<string, string>) => {
        const newParams = new URLSearchParams(searchParams);
        Object.entries(params).forEach(([key, value]) => {
            newParams.set(key, value);
        });
        setSearchParams(newParams);
    };

    return {
        getParam,
        setParam,
        removeParam,
        setMultipleParams,
    };
};
